import { CAPTION_FONTS } from '@reelplicate/flows';
import { useEffect, useState } from 'react';

let loading: Promise<void> | undefined;

/**
 * Loads the caption styles' fonts - the same files the slide renderer draws
 * with - once per page. A font that fails to load falls back quietly.
 */
export function loadCaptionFonts(): Promise<void> {
  if (loading) return loading;
  if (
    typeof FontFace === 'undefined' ||
    typeof document === 'undefined' ||
    !document.fonts
  ) {
    return (loading = Promise.resolve());
  }
  loading = Promise.all(
    CAPTION_FONTS.map((font) =>
      new FontFace(font.family, `url(/api/v1/caption-fonts/${font.file})`, {
        weight: String(font.weight),
        style: font.style,
      })
        .load()
        .then((face) => {
          document.fonts.add(face);
        })
        .catch(() => undefined),
    ),
  ).then(() => undefined);
  return loading;
}

/** Whether the caption fonts are ready to draw with. */
export function useCaptionFonts(): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let live = true;
    void loadCaptionFonts().then(() => {
      if (live) setReady(true);
    });
    return () => {
      live = false;
    };
  }, []);
  return ready;
}
